import React, { useState } from 'react';

export const useAggregatedState = (source) => {
    const [state, _setState] = useState(source);
    const setState = (newState) => {
        _setState(prevState => {
            return Object.assign({ ...prevState }, newState);
        });
    };

    return [state, setState];
}